// CLIENT PORTAL THEME — Top of the Line Tree Services LLC
// Dark green surfaces with the company's signature gold accent (#F4CE0A).
// Do NOT put any Yosi Media colors or branding in this file.

export const T = {
  // Surfaces (Top of the Line deep-forest palette)
  bg: "#0A2415",           // canvas — deepest forest
  side: "#082014",         // sidebar — even deeper
  card: "#0F3A22",         // card surface — pine
  card2: "#134A2C",        // elevated card / hover
  input: "#0B2818",        // input background
  border: "rgba(244,206,10,0.10)",
  borderHi: "rgba(244,206,10,0.42)",

  // Brand — company gold
  gold: "#F4CE0A",
  goldHi: "#F8DC3D",
  goldSoft: "rgba(244,206,10,0.14)",

  // Text (bone/cream — matches public website)
  text: "#F1EDE3",
  textDim: "rgba(241,237,227,0.66)",
  textFaint: "rgba(241,237,227,0.42)",

  // Status colors
  success: "#3DB85C",      // healthy green — matches tree brand
  info: "#60A5FA",
  warning: "#F59E0B",
  danger: "#EF4444",
  purple: "#A78BFA",

  // Radii + shadows
  r: "14px",
  rLg: "18px",
  shadow: "0 8px 32px rgba(0,0,0,0.42)",
};

export const CARD = { background: T.card, border: `1px solid ${T.border}`, borderRadius: T.r };
export const CARD_ELEV = { background: T.card2, border: `1px solid ${T.border}`, borderRadius: T.r };
export const INP = { background: T.input, border: `1px solid ${T.border}`, color: T.text, borderRadius: 10 };
export const BTN_GOLD = { background: T.gold, color: "#0A2415" };
export const BTN_GHOST = { background: "transparent", border: `1px solid ${T.border}`, color: T.text };

export const STATUS = {
  new: T.gold,
  contacted: T.info,
  scheduled: T.purple,
  in_progress: T.warning,
  completed: T.success,
  done: T.success,
  cancelled: T.danger,
  archived: T.textFaint,
  requested: T.gold,
  confirmed: T.success,
};

export const STATUS_LABEL = {
  new: "New",
  contacted: "Contacted",
  scheduled: "Scheduled",
  in_progress: "In Progress",
  completed: "Completed",
  done: "Completed",
  cancelled: "Cancelled",
  archived: "Archived",
  requested: "Requested",
  confirmed: "Confirmed",
};

export const QUOTE_STATUS_OPTIONS = [
  "new", "contacted", "scheduled", "in_progress", "completed", "cancelled", "archived",
];

export const BOOKING_STATUS_OPTIONS = ["requested", "confirmed", "completed", "cancelled"];

// Client-portal brand (public identity)
export const CLIENT_BRAND = {
  primary: "#0E3D22",
  gold: "#F4CE0A",
  name: "Top of the Line Tree Services LLC",
  logo: "/logo-top-of-the-line.png",
};
